"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
require("core-js/modules/es6.regexp.replace");
var _regeneratorRuntime2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _interopRequireWildcard2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/interopRequireWildcard.js"));
var _auth = require("@/utils/auth");
var _index = _interopRequireDefault(require("@/components/NavBarTop/index.vue"));
var _user = require("@/api/system/user");
var _utils = require("@/utils");
var _version = _interopRequireDefault(require("@/utils/version"));
var _vuex = require("vuex");
var _config = require("@/api/common/config");
var _date = require("@/utils/date");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 异步加载组件，提升首屏加载速度
var UserLogin = function UserLogin() {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("./components/userLogin"));
  });
};
var ForgetPassWord = function ForgetPassWord() {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("./components/forgetPassWord"));
  });
};
var _default = exports.default = {
  name: 'Login',
  components: {
    UserLogin: UserLogin,
    ForgetPassWord: ForgetPassWord,
    Navbar: _index.default
  },
  data: function data() {
    var _this = this;
    var validateUsername = function validateUsername(rule, value, callback) {
      if (!value || value.length === 0) {
        callback(new Error(_this.$t('login.userError')));
      } else {
        callback();
      }
    };
    var validatePassword = function validatePassword(rule, value, callback) {
      if (!value || value.length === 0) {
        callback(new Error(_this.$t('login.passwordRequire')));
      }
      callback();
    };
    var validateCheckCode = function validateCheckCode(rule, value, callback) {
      if (!value || value.length === 0) {
        callback(new Error(_this.$t('login.checkRequire')));
      } else if (value.length !== 4) {
        callback(new Error(_this.$t('login.checkError')));
      } else {
        callback();
      }
    };
    return {
      // 性能优化相关状态
      showUserLogin: false,
      showForgetPassword: false,
      bannerMapImage: '',
      timeList: [{
        value: '1',
        labelZh: '提单号',
        labelEh: 'B/L NO.'
      }, {
        value: '2',
        labelZh: '箱号',
        labelEh: 'Cntr No.'
      }],
      form: {
        pol: '',
        pod: '',
        vesselCode: '',
        blNo: '',
        currentFlag: '1'
      },
      hoveredTab: null,
      activeTab: 0,
      imgCodeList: [{
        url: require("../../../assets/img/weixinpublic.jpg"),
        text: '扫码关注微信公众号',
        textEn: 'WECHAT'
      }, {
        url: require("../../../assets/img/ios.jpg"),
        text: '下载IOS小程序',
        textEn: 'iPhone Version'
      }, {
        url: require("../../../assets/img/android.png"),
        text: '下载安卓小程序',
        textEn: 'Android Version'
      }],
      navTabList: [],
      tabList: [{
        name: '船期查询',
        nameEn: 'Shipping Schedule'
      }, {
        name: '船舶动态&汇率',
        nameEn: 'Vessel Movement'
      }, {
        name: '货物跟踪',
        nameEn: 'Cargo Tracking'
      }],
      navList: [],
      imgList: {},
      version: _version.default,
      loginBg: require('@/assets/img/banner.webp'),
      loginForm: {
        username: '',
        password: '',
        captchaCode: '',
        errorTimes: 0
      },
      loginRules: {
        username: [{
          required: true,
          trigger: 'blur',
          validator: validateUsername
        }],
        password: [{
          required: true,
          trigger: 'blur',
          validator: validatePassword
        }],
        captchaCode: [{
          required: true,
          trigger: 'blur',
          validator: validateCheckCode
        }]
      },
      passwordType: 'password',
      capsTooltip: false,
      loading: null,
      redirect: undefined,
      otherQuery: {},
      captchaUrl: '',
      showCheckCode: false,
      passwordStrengthText: '',
      passwordStrengthTextEn: '',
      passwordStrengthColor: '',
      radio: 'en',
      isEditPassword: false,
      isSticky: false,
      currentIndex: null,
      dialogVisible: true,
      showMobileMenu: false
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo'])),
  watch: {
    $route: {
      handler: function handler(route) {
        var query = route.query;
        console.log('query8888', route, query);
        if (query) {
          this.redirect = query.redirect;
          this.otherQuery = this.getOtherQuery(query);
        }
      },
      immediate: true
    }
  },
  created: function created() {
    var _this2 = this;
    // 延迟加载非关键资源，优化首屏加载
    this.$nextTick(function () {
      _this2.loadNonCriticalResources();
    });
  },
  mounted: function mounted() {
    var _this3 = this;
    // 预加载关键图片
    this.preloadCriticalImages();

    // 初始化导航数据
    this.initNavList();

    // 预先初始化登录和忘记密码组件，避免点击两次的问题
    this.showUserLogin = true;
    this.showForgetPassword = true;
    this.$nextTick(function () {
      // 初始化后立即隐藏
      _this3.showUserLogin = false;
      _this3.showForgetPassword = false;
    });

    // 添加滚动监听
    window.addEventListener('scroll', this.handleScroll);

    // 延迟检查公告板，避免阻塞首屏渲染
    setTimeout(function () {
      _this3.checkSuggestionBoard();
    }, 1000);
  },
  beforeDestroy: function beforeDestroy() {
    // 清理事件监听器
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    // 性能优化方法
    preloadCriticalImages: function preloadCriticalImages() {
      var _this4 = this;
      // 预加载banner地图图片
      var img = new Image();
      img.onload = function () {
        _this4.bannerMapImage = require('@/assets/img/banner_map_20241231.jpg');
      };
      img.onerror = function () {
        console.warn('Banner地图图片预加载失败');
        _this4.bannerMapImage = require('@/assets/img/banner_map_20241231.jpg');
      };
      img.src = require('@/assets/img/banner_map_20241231.jpg');
    },
    loadNonCriticalResources: function loadNonCriticalResources() {
      // 延迟加载二维码图片等非关键资源
      setTimeout(function () {
        // 这里可以加载其他非关键资源
        console.log('非关键资源加载完成');
      }, 500);
    },
    checkSuggestionBoard: function () {
      var _checkSuggestionBoard = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return (0, _user.showSuggestionBoard)();
            case 3:
              res = _context.sent;
              if (res.data) {
                this.dialogVisible = true;
              }
              _context.next = 10;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              console.warn('获取公告板信息失败:', _context.t0);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 7]]);
      }));
      function checkSuggestionBoard() {
        return _checkSuggestionBoard.apply(this, arguments);
      }
      return checkSuggestionBoard;
    }(),
    initNavList: function initNavList() {
      this.navList = [{
        nameEn: 'Home',
        nameZh: '首页',
        path: '/home'
      }, {
        nameEn: 'Schedule',
        nameZh: '船期',
        path: '/basicInfo/product'
      }, {
        nameEn: 'Booking',
        nameZh: '订舱',
        path: '/basicInfo/about'
      }, {
        nameEn: 'Information',
        nameZh: '信息查询',
        path: '/basicInfo/solution'
      }, {
        nameEn: 'Inbound',
        nameZh: '进口',
        path: '/basicInfo/contact'
      }, {
        nameEn: 'Equipment',
        nameZh: '箱管',
        path: '/basicInfo/service'
      }, {
        nameEn: 'Contact Us',
        nameZh: '联系我们',
        path: '/basicInfo/contact'
      }];
    },
    skipToPortContacts: function skipToPortContacts() {
      var routeUrl = this.$router.resolve({
        path: '/portContacts',
        query: {
          deptId: 'b9e7b5b3fb6724be9f8e2f84bfebc5d4'
        }
      });
      window.open(routeUrl.href);
    },
    handleHelp: function handleHelp() {
      var url = '/#/helpDocuments';
      window.open(url);
    },
    handleClickNav: function handleClickNav(item, index) {
      this.currentIndex = index;
      if (!item.iconLogin) {
        var url = "/#".concat(item.path);
        window.open(url);
      } else if ((0, _auth.getToken)() && item.isOpen) {
        var _url = "/#".concat(item.path);
        window.open(_url);
      } else if ((0, _auth.getToken)() && item.path === '/topMenu/vesselInfo') {
        var _url2 = "/#".concat(item.path);
        window.open(_url2);
      } else if (!(0, _auth.getToken)() && item.path === '/topMenu/vesselInfo') {
        this.$message({
          message: this.$t('home.noLoginMessage'),
          type: 'warning'
        });
      } else {
        this.$router.push({
          path: item.path
        });
      }
    },
    handleScroll: function handleScroll() {
      this.isSticky = window.scrollY > 0;
    },
    handleLogOut: function handleLogOut() {
      var _this5 = this;
      this.$confirm(this.$t('home.logOutMessage'), this.$t('confirmMsg.title'), {
        confirmButtonText: this.$t('home.sumit'),
        cancelButtonText: this.$t('home.cancelButton'),
        type: 'warning'
      }).then(function () {
        _this5.$store.dispatch('user/logoutAuth');
        _this5.$router.push({
          path: '/home'
        });
      }).catch(function () {
        // 用户取消登出
      });
    },
    handleForgetPassword: function handleForgetPassword(data) {
      var _this6 = this;
      this.isEditPassword = data;
      this.showForgetPassword = true;
      this.$nextTick(function () {
        _this6.$refs.forgetPassWord.forgetDialogVisible = true;
      });
    },
    handleSetLanguage: function handleSetLanguage(lang) {
      var _this7 = this;
      this.$i18n.locale = lang;
      this.$store.dispatch('app/setLanguage', lang);
      var view = this.$route;
      this.$store.dispatch('tagsView/delCachedView', view).then(function () {
        var fullPath = view.fullPath;
        _this7.$nextTick(function () {
          _this7.$router.replace({
            path: '/redirect' + fullPath
          });
        });
      });
    },
    calculateDates: _date.calculateDates,
    changePort: function changePort(val, row) {
      this.form.pol = row.portName;
    },
    changePortPod: function changePortPod(val, row) {
      this.form.pod = row.portName;
    },
    changeVessel: function changeVessel(val, row) {
      this.form.vesselName = row.vesselName;
    },
    handleSearchPort: function handleSearchPort() {
      var date = new Date();
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      var d = date.getDate();
      var date1 = y + '-' + m + '-' + d;
      var dateto = (0, _date.calculateDates)(date1, 7);
      this.$router.push({
        name: 'voyagePlanSearch',
        params: {
          pol: this.form.pol,
          pod: this.form.pod,
          datefrom: date1,
          dateto: dateto
        }
      });
    },
    handleSearchVessel: function handleSearchVessel() {
      this.$router.push({
        name: 'vesselMovementSearch',
        params: {
          vesselCode: this.form.vesselCode,
          vesselName: this.form.vesselName
        }
      });
    },
    handleSearchBlNo: function handleSearchBlNo() {
      if (this.form.currentFlag === '1') {
        this.form.containerNo = '';
      } else {
        this.form.containerNo = this.form.blNo;
        this.form.blNo = '';
      }
      if (!this.form.blNo && !this.form.containerNo) {
        this.$message({
          message: this.$t('home.pleaseWriteBlno'),
          type: 'warning'
        });
        return;
      }
      this.$router.push({
        name: 'cargoTrack',
        params: {
          blNo: this.form.blNo,
          containerNo: this.form.containerNo
        }
      });
    },
    handleGoLogin: function handleGoLogin() {
      var _this8 = this;
      this.showUserLogin = true;
      this.$nextTick(function () {
        _this8.$refs.userLogin.dialogVisible = true;
      });
    },
    handleToUserCenter: function handleToUserCenter() {
      this.$router.push({
        path: '/userCenter/userCenter'
      });
    },
    hoverTabLeave: function hoverTabLeave() {
      this.hoveredTab = null;
      this.navTabList = [];
      this.currentIndex = null;
    },
    selectSecondTab: function selectSecondTab(index) {
      if (index === 4) {
        this.navTabList = [{
          name: this.$t('home.importTwo'),
          path: '/topMenu/cargoInfoSearch',
          'iconAuth': false,
          'iconLogin': true,
          'isOpen': true
        }, {
          name: this.$t('home.importThree'),
          path: '/import/blExchangeAppointment',
          'iconAuth': true,
          'iconLogin': true
        }, {
          name: this.$t('home.importFour'),
          path: '/import/appointmentHistory',
          'iconAuth': true,
          'iconLogin': true
        }, {
          name: this.$t('home.importFive'),
          path: '/import/blExchangeAppointmentSh',
          'iconAuth': true,
          'iconLogin': true
        }, {
          name: this.$t('home.importSix'),
          path: '/import/appointmentHistorySh',
          'iconAuth': true,
          'iconLogin': true
        }, {
          name: this.$t('home.appointmentHistorySh'),
          path: '/settlementManagement/importBillUpload',
          'iconAuth': true,
          'iconLogin': true
        }, {
          name: this.$t('home.importOne'),
          path: '/topMenu/delivery',
          'iconAuth': false,
          'iconLogin': true,
          'isOpen': true
        }];
      }
      if (index === 2) {
        this.navTabList = [{
          name: this.$t('home.controlOne'),
          path: '/bookingSpace/bookingSpaceList',
          'iconAuth': true,
          'iconLogin': true
        }, {
          name: this.$t('home.controlTwo'),
          path: '/bookingSpace/bookingSpaceMy',
          'iconAuth': true,
          'iconLogin': true
        }, {
          name: this.$t('home.controlThree'),
          path: '/bookingSpace/bookingJapan',
          'iconAuth': true,
          'iconLogin': true
        },
        // {
        //   name: this.$t('home.controlFour'),
        //   path: '/bookingSpace/bookingHistoryJp',
        //   'iconAuth': true,
        //   'iconLogin': true
        // },
        {
          name: this.$t('home.controlFive'),
          path: '/topMenu/vgmApply',
          'iconAuth': false,
          'iconLogin': true,
          'isOpen': true
        }, {
          name: this.$t('home.controlSix'),
          path: '/bookingSpace/dangerousDeclaration',
          'iconAuth': true,
          'iconLogin': true
        }, {
          name: this.$t('home.controlSeven'),
          path: '/bookingSpace/newManifestEDI',
          'iconAuth': true,
          'iconLogin': true
        }, {
          name: this.$t('home.controlEight'),
          path: '/bookingSpace/ediFeedBack',
          'iconAuth': true,
          'iconLogin': true
        }, {
          name: this.$t('home.controlNine'),
          path: '/bookingSpace/myBookingTemplate',
          'iconAuth': true,
          'iconLogin': true
        }, {
          name: this.$t('home.exportCostSlipUpload'),
          path: '/settlementManagement/exportCostSlipUpload',
          'iconAuth': true,
          'iconLogin': true
        }];
      }
      if (index === 3) {
        this.navTabList = [{
          name: this.$t('home.infoOne'),
          path: '/topMenu/cargoTrack',
          'iconAuth': false,
          'iconLogin': false
        }, {
          name: this.$t('home.infoTwo'),
          path: '/topMenu/release',
          'iconAuth': false,
          'iconLogin': true,
          'isOpen': true
        }, {
          name: this.$t('home.infoThree'),
          path: '/topMenu/dangerCargoSpecContainer',
          'iconAuth': false,
          'iconLogin': true,
          'isOpen': true
        }, {
          name: this.$t('home.infoFour'),
          path: '/topMenu/surchargeAndMiscellaneous',
          'iconAuth': false,
          'iconLogin': false
        }, {
          name: this.$t('home.infoFive'),
          path: '/topMenu/carbonCalculator',
          'iconAuth': false,
          'iconLogin': false
        }, {
          name: this.$t('home.infoSix'),
          path: '/topMenu/searchFile',
          'iconAuth': false,
          'iconLogin': false
        }];
      }
      if (index === 5) {
        this.navTabList = [{
          name: this.$t('home.containerOne'),
          path: '/topMenu/equipmentFee',
          'iconAuth': false,
          'iconLogin': false,
          'isOpen': true
        }, {
          name: this.$t('home.containerTwo'),
          path: '/topMenu/containerInfo',
          'iconAuth': false,
          'iconLogin': true,
          'isOpen': true
        }, {
          name: this.$t('home.containerThree'),
          path: '/topMenu/tariffs',
          'iconAuth': false,
          'iconLogin': false
        }, {
          name: this.$t('home.containerFour'),
          path: '/topMenu/demurrageCalculation',
          'iconAuth': false,
          'iconLogin': true,
          'isOpen': true
        }];
      }
      if (index === 1) {
        this.navTabList = [{
          name: this.$t('home.vesselOne'),
          path: '/topMenu/voyagePlanSearch'
        }, {
          name: this.$t('home.vesselTwo'),
          path: '/topMenu/vesselMovementSearch'
        }, {
          name: this.$t('home.vesselThree'),
          path: '/topMenu/vesselInfo',
          'iconAuth': false,
          'iconLogin': true
        }];
      }
      if (index === 6) {
        this.navTabList = [{
          name: this.$t('home.suggest'),
          path: '/topMenu/issueApply',
          'iconLogin': true,
          'iconAuth': false
        }, {
          name: this.$t('home.branch'),
          path: '/portContacts',
          'isOpen': true
        }];
      }
    },
    adjustSecondTabPosition: function adjustSecondTabPosition(index) {
      // 获取当前鼠标移动到的container-box-item元素
      var containerBoxItem = this.$refs.containerBoxItem[index];
      var rect = containerBoxItem.getBoundingClientRect();

      // 获取container-list-tab元素
      var containerListTab = this.$refs.containerListTab;

      // 设置container-list-tab的位置
      // containerListTab.style.top = `${rect.bottom}px`;
      var left = rect.left < 425 ? 425 : rect.left;
      containerListTab.style.left = "".concat(left, "px");

      // 获取container-list-tab的尺寸
      var tabRect = containerListTab.getBoundingClientRect();

      // 获取窗口的宽度
      var windowWidth = window.innerWidth;

      // 检查container-list-tab是否超出了屏幕的宽度
      if (tabRect.right > windowWidth) {
        // 调整container-list-tab的left属性，使其完全在屏幕内
        containerListTab.style.left = "".concat(windowWidth - tabRect.width, "px");
      }
    },
    hoverTab: function hoverTab(index) {
      this.hoveredTabBox = index;
      this.hoveredTab = index;
      this.selectSecondTab(index);
      this.adjustSecondTabPosition(index);
    },
    checkCapslock: function checkCapslock(e) {
      var key = e.key;
      this.capsTooltip = key && key.length === 1 && key >= 'A' && key <= 'Z';
    },
    showPwd: function showPwd() {
      var _this9 = this;
      this.passwordType = '';
      this.$nextTick(function () {
        _this9.$refs.password.focus();
      });
    },
    hidePwd: function hidePwd() {
      var _this10 = this;
      this.passwordType = 'password';
      this.$nextTick(function () {
        _this10.$refs.password.focus();
      });
    },
    /* 登录 */handleLogin: function handleLogin() {
      var _this11 = this;
      this.$refs.loginForm.validate(function (valid) {
        if (valid) {
          _this11.loading = (0, _utils.load)();
          var data = (0, _utils.deepClone)(_this11.loginForm);
          if (!_this11.showCheckCode) {
            delete data.captchaCode;
            delete data.errorTimes;
          }
          data.appCode = _this11.config.appCode;
          _this11.$store.dispatch('user/login', data).then(function (res) {
            _this11.$router.push({
              path: _this11.redirect || '/basicInfo/userGuide',
              query: _this11.otherQuery
            });
            _this11.checkVersionToReload();
          }).catch(function (err) {
            if (!err) {
              _this11.$message({
                message: '系统错误',
                type: 'error'
              });
              // 认证服务宕机
            } else if (typeof err === 'string' && (err.indexOf('502') > -1 || err.indexOf('404') > -1)) {
              _this11.$message({
                message: _this11.$t('login.loginServerErrTip'),
                type: 'error'
              });
            } else {
              // 其他服务宕机
              if (err.errorMessages && err.errorMessages[0].indexOf('远端服务调用异常') > -1) {
                _this11.$message({
                  message: _this11.$t('login.loginServerErrTip'),
                  type: 'error'
                });
              } else {
                if (err.errorCode == 500001) {
                  _this11.$message({
                    message: _this11.$t('login.checkCodeHolder'),
                    type: 'error'
                  });
                } else {
                  _this11.$message({
                    message: err.errorMessages[0].indexOf('400') > -1 ? _this11.$t('login.loginErrTip') : err.errorMessages[0],
                    type: 'error'
                  });
                }
              }
            }
          }).finally(function () {
            _this11.loading.close();
          });
        } else {
          return false;
        }
      });
    },
    // 判断版本号，版本号修改后刷新界面
    checkVersionToReload: function checkVersionToReload() {
      var _this12 = this;
      (0, _config.getDeployLocation)().then(function (res) {
        if (_this12.$store.getters.version !== res.data.displayValue) {
          location.reload(true);
        }
      });
    },
    /* 获取验证码 */getCaptcha: function getCaptcha() {
      var _this13 = this;
      (0, _user.captcha)().then(function (res) {
        var data = res; // 返回的数据
        var url = window.URL.createObjectURL(new Blob([data])); // 此url如是图片格式，可赋值<img :src="url"> 做展示
        _this13.captchaUrl = url;
      });
    },
    /* 检验密码的复杂程度 */passwordStrength: function passwordStrength(str) {
      if (!str) {
        this.passwordStrengthText = '';
        this.passwordStrengthTextEn = '';
        return;
      }
      var _color = ['red', 'gray', 'orange', 'green'];
      var msgs = ['密码太短', '弱', '中', '强'];
      var msgsEn = ['Too Short', 'Weak', 'Medium', 'Strong'];
      var _strength = 0;
      var _v = str.replace(/^(\s|\u00a0)+|(\s|\u00a0)+$/g, '');
      var _vL = _v.length;
      var i = 0;
      var charStrength = function charStrength(char) {
        // 计算单个字符强度
        if (char >= 48 && char <= 57) {
          // 数字
          return 1;
        }
        if (char >= 97 && char <= 122) {
          // 小写
          return 2;
        } else {
          return 3; // 特殊字符
        }
      };
      if (_vL < 6) {
        // 计算模式
        this.passwordStrengthText = msgs[0];
        this.passwordStrengthTextEn = msgsEn[0];
        this.passwordStrengthColor = _color[0];
      } else {
        for (; i < _vL; i++) {
          // 遍历字符
          _strength += charStrength(_v.toLocaleLowerCase().charCodeAt(i));
        }
        if (_strength < 10) {
          // 强度小于10
          this.passwordStrengthText = msgs[1];
          this.passwordStrengthTextEn = msgsEn[1];
          this.passwordStrengthColor = _color[1];
        }
        if (_strength >= 10 && _strength < 15) {
          this.passwordStrengthText = msgs[2];
          this.passwordStrengthTextEn = msgsEn[2];
          this.passwordStrengthColor = _color[2];
        }
        if (_strength >= 15) {
          this.passwordStrengthText = msgs[3];
          this.passwordStrengthTextEn = msgsEn[3];
          this.passwordStrengthColor = _color[3];
        }
      }
    },
    getOtherQuery: function getOtherQuery(query) {
      return Object.keys(query).reduce(function (acc, cur) {
        if (cur !== 'redirect') {
          acc[cur] = query[cur];
        }
        return acc;
      }, {});
    },
    toggleMobileMenu: function toggleMobileMenu() {
      this.showMobileMenu = !this.showMobileMenu;
    },
    handleMobileNavClick: function handleMobileNavClick(item, index) {
      this.currentIndex = index;
      if (!item.iconLogin) {
        var url = "/#".concat(item.path);
        window.open(url);
      } else if ((0, _auth.getToken)() && item.isOpen) {
        var _url3 = "/#".concat(item.path);
        window.open(_url3);
      } else if ((0, _auth.getToken)() && item.path === '/topMenu/vesselInfo') {
        var _url4 = "/#".concat(item.path);
        window.open(_url4);
      } else if (!(0, _auth.getToken)() && item.path === '/topMenu/vesselInfo') {
        this.$message({
          message: this.$t('home.noLoginMessage'),
          type: 'warning'
        });
      } else {
        this.$router.push({
          path: item.path
        });
      }
    }
  }
};